<template>
  <div class="variables-explanation" v-if="show">
    <separator/>
    <div @click="openVariablesExplanation" class="explain-variables-button">
      למה זה הכסף שנשאר לי להוציא?
    </div>
  </div>
</template>

<script>
import BaseUI from 'base-ui';
import { mapState } from 'vuex';
import ModalBus from '../../../../../../../../event-bus/modal-bus';
import Segment from '../../../../../../../../Segment';
import ExplainVariablesPopup from './ExplainVariablesPopup.vue';
import { SUBSCRIPTION_STATES } from '../../../../../../../../constants/subscription-state';

export default {
  name: 'VariablesExplanation',
  components: {
    Separator: BaseUI.Separator,
  },
  async created() {
    Segment.trackUserInteraction('ExplainVariablesDisplayed');
  },
  computed: {
    ...mapState('subscriptionState', ['subscriptionState']),
    show() {
      return this.subscriptionState === SUBSCRIPTION_STATES.TRIAL;
    },
  },
  methods: {
    openVariablesExplanation() {
      Segment.trackUserInteraction('ExplainVariablesClicked');
      ModalBus.$emit('open', {
        component: ExplainVariablesPopup,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import '../../../../../../../../../node_modules/base-ui/src/scss/riseup-colors';
  .variables-explanation {
    .explain-variables-button {
      padding: 17px 0;
      color: $riseup_light_blue;
      text-align: center;
      font-size: 16px;
      font-weight: bold;
      cursor: pointer;
    }
  }
</style>
